import { MediaPopover, type MediaPopoverProps } from "@components/ui-kit";
import { observer } from "mobx-react-lite";

type PreviewAndDownloadCellProps = Pick<MediaPopoverProps, "value"> & {
  hideDownload?: boolean;
};

const PreviewAndDownloadCell = ({
  value,
  hideDownload,
}: PreviewAndDownloadCellProps) => (
  <div className="inline-flex items-center space-x-5 ml-4">
    <MediaPopover type="preview" value={value} />
    {!hideDownload && <MediaPopover type="download" value={value} />}
  </div>
);

export default observer(PreviewAndDownloadCell);
